import React from "react";
import EventsComp from "../components/portal/events";
import Header from "../components/layout/Header";
import Footer from "../components/layout/footer";

const Events = () => {
  return (
    <div>
      <Header />
      <div className="container mx-auto px-4 py-52">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-2">Upcoming Events</h1>
          <p className="text-xl text-gray-600">
            Join us at our upcoming community events
          </p>
        </div>
        <EventsComp />
      </div>
      <Footer></Footer>
    </div>
  );
};

export default Events;
